/** Konverterer ISO-streng med offset til `YYYY-MM-DD` for `<input type="date">` (lokal kalenderdag). */
export function isoTimestampToDateInput(iso: string): string {
  const parsed = Date.parse(iso);
  if (!Number.isFinite(parsed)) return '';
  const date = new Date(parsed);
  return formatLocalDateParts(date);
}

/** Start av lokal kalenderdag som ISO med offset (felt `from`). */
export function dateInputToPeriodFrom(dateInput: string): string {
  const parts = parseDateInput(dateInput);
  if (!parts) throw new Error('Ugyldig fra-dato.');
  const date = new Date(parts.year, parts.monthIndex, parts.day, 0, 0, 0, 0);
  return formatIsoWithLocalOffset(date);
}

/** Slutt av lokal kalenderdag som ISO med offset (felt `to`). */
export function dateInputToPeriodTo(dateInput: string): string {
  const parts = parseDateInput(dateInput);
  if (!parts) throw new Error('Ugyldig til-dato.');
  const date = new Date(parts.year, parts.monthIndex, parts.day, 23, 59, 59, 999);
  return formatIsoWithLocalOffset(date);
}

interface DateInputParts {
  readonly year: number;
  readonly monthIndex: number;
  readonly day: number;
}

function parseDateInput(value: string): DateInputParts | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
  if (!match) return null;
  const year = Number(match[1]);
  const monthIndex = Number(match[2]) - 1;
  const day = Number(match[3]);
  const probe = new Date(year, monthIndex, day);
  if (probe.getFullYear() !== year || probe.getMonth() !== monthIndex || probe.getDate() !== day) {
    return null;
  }
  return { year, monthIndex, day };
}

function formatLocalDateParts(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

function formatIsoWithLocalOffset(date: Date): string {
  const pad = (n: number, width = 2) => String(n).padStart(width, '0');
  const offsetMinutes = -date.getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? '+' : '-';
  const abs = Math.abs(offsetMinutes);
  const offsetHours = pad(Math.floor(abs / 60));
  const offsetMins = pad(abs % 60);
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}.` +
    `${pad(date.getMilliseconds(), 3)}${sign}${offsetHours}:${offsetMins}`
  );
}
